/**
 * Arama reklamları hesabı bağlama — dönüş adresinin ERKEN temizlenmesi (v3.2 D; v3.1 K3 kuralları:
 * docs/security/v3-oauth-gunluk-guvenligi.md).
 *
 * Sağlayıcı kullanıcıyı `…/settings/connections/ads/google/callback?code=…&state=…` adresine TAM sayfa yüklemesiyle döndürür.
 * Dönüş sayfası tembel yüklenen bir parçadır ve ondan ÖNCE oturum denetimi, kabuk ve parça isteği çalışır: adres yalnız sayfa
 * bileşeninde temizlenseydi bu isteklerin hepsi yetki kodu adres çubuğundayken gönderilirdi. Bu yüzden sorgu, uygulama
 * çizilmeden ÖNCE — ilk API çağrısından önce — belleğe alınır ve adres çubuğundan + tarayıcı geçmişinden silinir (geçmiş kaydı
 * DEĞİŞTİRİLİR, yeni kayıt eklenmez).
 *
 * Değer yalnız bu modülün belleğindedir: yerel depoya, çereze, günlüğe ya da hata iletisine yazılmaz; dönüş sayfası bir kez
 * okur ve siler. Sayfa yenilenirse değer kaybolur (kod ve durum değeri zaten tek kullanımlıktır; bağlama yeniden başlatılır).
 * Sosyal medya reklam hesabı dönüşünden (`ad-connect-return.ts`) AYRI modül ve ayrı bellek: iki akışın değeri karışmaz.
 */
import { GOOGLE_ADS_CONNECT_CALLBACK_PATH } from '@castinflow/shared';

let captured: string | null = null;

/**
 * Uygulama çizilmeden önce bir kez çağrılır (`main.tsx`). Dönüş yolunda değilse ya da adres sorgu / parça taşımıyorsa hiçbir
 * şey yapmaz. Parça da silinir.
 */
export function captureGoogleAdsConnectReturn(
  win: Pick<Window, 'location' | 'history'> = window,
): void {
  const { pathname, search, hash } = win.location;
  if (pathname.replace(/\/+$/, '') !== GOOGLE_ADS_CONNECT_CALLBACK_PATH) return;
  if (search === '' && hash === '') return;
  captured = search;
  win.history.replaceState(win.history.state, '', GOOGLE_ADS_CONNECT_CALLBACK_PATH);
}

/**
 * Yakalanan sorgu dizgisi (yoksa `null`). Okumak silmez: geliştirme kipinde bileşenin ilk durumu iki kez hesaplanır ve ikisi de
 * aynı değeri görmelidir. Sayfa değeri kendi durumuna aldıktan sonra `clearGoogleAdsConnectReturn` çağırır.
 */
export function capturedGoogleAdsConnectReturn(): string | null {
  return captured;
}

/** Değer sayfanın durumuna alındı: modül belleğinden silinir */
export function clearGoogleAdsConnectReturn(): void {
  captured = null;
}
